<template>
  <v-dialog :model-value="modelValue" @click:outside="$emit('close')" @keydown.esc="$emit('close')" max-width="600px"
    transition="dialog-bottom-transition">
    <v-card>
      <v-form ref="form">
        <v-card-title class="d-flex align-center">
          <span class="headline">{{ title }}</span>
        </v-card-title>

        <v-card-text>
          <div class="space-y-4">
            <v-combobox 
              :model-value="filters.product_category" 
              density="comfortable" 
              @update:model-value="$emit('update:filters', { ...filters, product_category: $event })" autocomplete="off" name="product_category"
              item-title="name" item-value="id" :items="categories" 
              label="Rubro Producto" 
              clearable>
            </v-combobox>

            <v-text-field :model-value="filters.lote"
              @update:model-value="$emit('update:filters', { ...filters, lote: $event })" autocomplete="off" name="lote"
              label="Lote" type="text" clearable />

            <v-text-field :model-value="filters.serie"
              @update:model-value="$emit('update:filters', { ...filters, serie: $event })" autocomplete="off"
              name="serie" label="Nº Serie" type="text" clearable />

            <v-text-field v-if="isAliasEnabled('descriptivo_1')" :model-value="filters.descriptivo_1"
              @update:model-value="$emit('update:filters', { ...filters, descriptivo_1: $event })" autocomplete="off"
              name="descriptivo_1" :label="getAliasName('descriptivo_1')" type="text" clearable />

            <v-text-field v-if="isAliasEnabled('descriptivo_2')" :model-value="filters.descriptivo_2"
              @update:model-value="$emit('update:filters', { ...filters, descriptivo_2: $event })" autocomplete="off"
              name="descriptivo_2" :label="getAliasName('descriptivo_2')" type="text" clearable />

            <v-text-field v-if="isAliasEnabled('descriptivo_3')" :model-value="filters.descriptivo_3"
              @update:model-value="$emit('update:filters', { ...filters, descriptivo_3: $event })" autocomplete="off"
              name="descriptivo_3" :label="getAliasName('descriptivo_3')" type="text" clearable />

            <v-combobox :model-value="filters.quality"
              @update:model-value="$emit('update:filters', { ...filters, quality: $event })" name="quality"
              item-title="name" item-value="id" :items="qualities" label="Calidad" autocomplete="off" clearable />

            <v-combobox :model-value="filters.state"
              @update:model-value="$emit('update:filters', { ...filters, state: $event })" name="state"
              item-title="name" item-value="id" :items="states" label="Estado Producto" autocomplete="off" clearable />

            <v-row>
              <v-col cols="5">
                <v-combobox :model-value="filters.storage_units_amount_operator"
                  @update:model-value="updateStorageUnitsOperator($event)"
                  :items="comparisonOperators" item-title="label" item-value="value" label="Comparador"
                  clearable />
              </v-col>
              <v-col cols="7">
                <v-text-field :model-value="filters.storage_units_amount"
                  @update:model-value="$emit('update:filters', { ...filters, storage_units_amount: $event })"
                  autocomplete="off" name="storage_units_amount" label="Valor de almacenamiento" type="number" clearable
                  :disabled="!filters.storage_units_amount_operator" />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="5">
                <v-combobox :model-value="filters.expiration_date_operator"
                  @update:model-value="updateExpirationDateOperator($event)"
                  :items="comparisonOperators" item-title="label" item-value="value" label="Comparador"
                  clearable />

              </v-col>
              <v-col cols="7">
                <v-text-field :model-value="filters.expiration_date"
                  @update:model-value="$emit('update:filters', { ...filters, expiration_date: $event })"
                  autocomplete="off" name="expiration_date" label="Fecha de vencimiento" type="date" clearable
                  :disabled="!filters.expiration_date_operator" />
              </v-col>
            </v-row>

          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" variant="text" @click="$emit('close')">
            Cancelar
          </v-btn>
          <v-btn color="success" variant="text" @click="$emit('apply')" :loading="loading">
            Aplicar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { rubroService } from "@/libs/ws/rubroService";

export default {
  name: 'ModalFilterAttribute',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Filtros Adicionales'
    },
    filters: {
      type: Object,
      required: true
    },
    qualities: {
      type: Array,
      default: () => []
    },
    states: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    isAliasEnabled: {
      type: Function,
      required: true
    },
    getAliasName: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      comparisonOperators: [
        { label: 'Igual a', value: 'eq' },
        { label: 'Mayor igual a', value: 'gte' },
        { label: 'Menor igual a', value: 'lte' }
      ],
      categories: []
    };
  },
  emits: ['update:modelValue', 'update:filters', 'close', 'apply'],
  mounted() {    
    this.loadCategorias();
  },
  methods: {
    loadCategorias() {
      rubroService
        .filter()
        .then((response) => {
          console.log("categorias", response.result);
          this.categories = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    updateStorageUnitsOperator(value) {
      const updatedFilters = { 
        ...this.filters, 
        storage_units_amount_operator: value 
      };
      
      if (!value) {
        updatedFilters.storage_units_amount = null;
      }
      
      this.$emit('update:filters', updatedFilters);
    },
    
    updateExpirationDateOperator(value) {
      const updatedFilters = { 
        ...this.filters, 
        expiration_date_operator: value 
      };
      
      if (!value) {
        updatedFilters.expiration_date = null;
      }
      
      this.$emit('update:filters', updatedFilters);
    }
  },
  watch: {
    modelValue(newVal) {
      if (!newVal) {
        this.$emit('close');
      }
    }
  }
};
</script>

<style scoped>
.space-y-4>*+* {
  margin-top: 1rem;
}
</style>
